if (!customElements.get("collection-feature")) {
  customElements.define(
    "collection-feature",
    class CollectionFeature extends HTMLElement {
      constructor() {
        super();
        // Bind the changeColors method to ensure the correct this context
        this.changeColors = this.changeColors.bind(this);
        this.resetColors = this.resetColors.bind(this);
      }

      connectedCallback() {
        // Initialize component properties
        this._initProperties();
        // Attach event listeners
        this._attachEventListeners();
      }

      // Initialize component properties
      _initProperties() {
        this.sectionId = this.dataset.sectionId;
        // Sekcija je parent div (wrapper) koji sadrži ovaj element
        this.section = this.closest("[data-section-id]");
        if (!this.section) {
          this.section = document.querySelector(
            `[data-section-id="${this.sectionId}"]`,
          );
        }
        if (!this.section) {
          console.error("Section not found");
          return;
        }
        this.items = this.querySelectorAll(".collection-feature__item");
      }

      // Attach event listeners to items
      _attachEventListeners() {
        if (!this.items || this.items.length === 0) return;

        this.items.forEach((item) => {
          item.addEventListener("mouseover", () => this.changeColors(item));
          item.addEventListener("mouseleave", this.resetColors);
          // Na mobilnom tap ne pokreće mouseover – primeni iste boje na touch/click
          item.addEventListener("touchstart", (e) => {
            const target = e.currentTarget;
            if (target && target.dataset.hoverColor) this.changeColors(target);
          }, { passive: true });
          item.addEventListener("click", (e) => {
            const target = e.currentTarget;
            if (target && target.dataset.hoverColor) this.changeColors(target);
          });
        });

        // Dodatno: listener na samom linku da uhvati tap (event može da ne stigne do li)
        this.querySelectorAll(".collection-feature__link").forEach((link) => {
          link.addEventListener("touchstart", (e) => {
            const item = e.currentTarget.closest(".collection-feature__item");
            if (item && item.dataset.hoverColor) this.changeColors(item);
          }, { passive: true });
          link.addEventListener("click", (e) => {
            const item = e.currentTarget.closest(".collection-feature__item");
            if (item && item.dataset.hoverColor) this.changeColors(item);
          });
        });
      }

      // Samo link na koji je kliknuto/hover postaje žut (ili hover boja)
      changeColors(item) {
        if (!item) return;
        this._clearAllItemStyles();
        const color = (item.dataset.hoverColor || "").trim();
        const background = (item.dataset.hoverBackground || "").trim();
        const link = item.querySelector(".collection-feature__link");
        if (link && color) link.style.color = color;
        if (background) item.style.backgroundColor = background;
      }

      _clearAllItemStyles() {
        if (!this.items) return;
        this.items.forEach((it) => {
          it.style.backgroundColor = "";
          const link = it.querySelector(".collection-feature__link");
          if (link) link.style.color = "";
        });
      }

      resetColors() {
        this._clearAllItemStyles();
      }

      disconnectedCallback() {
        // Properly remove event listeners
        this.items.forEach((item) => {
          item.removeEventListener("mouseover", this.changeColors);
          item.removeEventListener("mouseleave", this.resetColors);
        });
      }
    },
  );
  
}
